<template>
  <div v-if="isLoading" class="w-full h-full fixed top-0 left-0 bg-white opacity-75 z-50">
    <div class="flex justify-center items-center mt-[50vh]">
      <div role="status">
        <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill" />
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
      <img class="mx-auto h-[50%] w-[50%]" src="@/assets/smartbible_logo.png" alt="Your Company" />
      <h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Sign in to your account
      </h2>
    </div>

    <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
      <form class="space-y-6" @submit.prevent="login" method="POST">
        <div>
          <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address</label>
          <div class="mt-2">
            <input v-model="email" id="email" name="email" type="email" autocomplete="email" required="true"
              class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
          </div>
        </div>

        <div>
          <div class="flex items-center justify-between">
            <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password</label>
          </div>
          <div class="mt-2">
            <input v-model="password" id="password" name="password" type="password" autocomplete="current-password"
              required="true"
              class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
          </div>
        </div>

        <div>
          <button type="submit"
            class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Sign
            in</button>
        </div>
      </form>
      <br>
      <div class="flex justify-center">
        <GoogleLogin :callback="callback" />
      </div>
    </div>
  </div>
</template>

<script>
import { decodeCredential } from 'vue3-google-login'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      email: "",
      password: "",
      isLoading: false,
    }
  },
  methods: {
    async login() {
      this.isLoading = true
      const auth = getAuth()
      await signInWithEmailAndPassword(auth, this.email, this.password).then((data) => {
        sessionStorage.setItem("credential", JSON.stringify(data.user))
        sessionStorage.setItem("token", JSON.stringify(data.user.accessToken))
        this.$store.dispatch('login', {
          email: this.email
        }).then(() => {
          if (this.userDataLogin !== null) {
            if (this.userDataLogin.data.pic) {
              sessionStorage.setItem("userData", JSON.stringify(this.userDataLogin.data))
              this.$router.push({ name: "role" })
            } else {
              Swal.fire({
                title: "Error",
                text: "Anda Tidak Diperbolehkan Akses",
                icon: "error"
              }).then(() => {
                sessionStorage.removeItem('credential')
                sessionStorage.removeItem('token')
                sessionStorage.removeItem('userData')
                sessionStorage.removeItem('role')
                sessionStorage.removeItem('agensi')
                sessionStorage.removeItem('subKomunitas')
                this.isLoading = false
                this.$router.push({ name: 'login' })
              })
            }
          } else {
            Swal.fire({
              title: "Error",
              text: "Anda Tidak Diperbolehkan Akses",
              icon: "error"
            }).then(() => {
              sessionStorage.removeItem('credential')
              sessionStorage.removeItem('token')
              sessionStorage.removeItem('userData')
              sessionStorage.removeItem('role')
              sessionStorage.removeItem('agensi')
              sessionStorage.removeItem('subKomunitas')
              this.isLoading = false
              this.$router.push({ name: 'login' })
            })
          }
        })
          .catch((error) => {
            this.$swal
              .fire({
                icon: "error",
                title: "Oops...",
                text: "Bad Credentials! " + error.message,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.username = ""
                  this.password = ""
                  this.isLoading = false
                }
              })
          })
      }).catch((error) => {
        this.$swal
          .fire({
            icon: "error",
            title: "Oops...",
            text: "Bad Credentials! " + error.message,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.username = ""
              this.password = ""
              this.isLoading = false
            }
          })
      })


    },
    async callback(response) {
      this.isLoading = true
      const userData = decodeCredential(response.credential)
      sessionStorage.setItem("credential", JSON.stringify(userData))
      sessionStorage.setItem("token", JSON.stringify(response.credential))
      await this.$store.dispatch('loginByGoogle', {
        email: JSON.parse(sessionStorage.getItem('credential')).email,
      })

      if (this.userDataLoginByGoogle !== null) {
        if (this.userDataLoginByGoogle.data.pic) {
          sessionStorage.setItem("userData", JSON.stringify(this.userDataLoginByGoogle.data))
          this.$router.push({ name: "role" })
        } else {
          Swal.fire({
            title: "Error",
            text: "Anda Tidak Diperbolehkan Akses",
            icon: "error"
          }).then(() => {
            sessionStorage.removeItem('credential')
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('userData')
            sessionStorage.removeItem('role')
            sessionStorage.removeItem('agensi')
            sessionStorage.removeItem('subKomunitas')
            this.isLoading = false
            this.$router.push({ name: 'login' })
          })
        }
      } else {
        Swal.fire({
          title: "Error",
          text: "Anda Tidak Diperbolehkan Akses",
          icon: "error"
        }).then(() => {
          sessionStorage.removeItem('credential')
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('userData')
          sessionStorage.removeItem('role')
          sessionStorage.removeItem('agensi')
          sessionStorage.removeItem('subKomunitas')
          this.isLoading = false
          this.$router.push({ name: 'login' })
        })
      }
    }
  },
  computed: {
    userDataLoginByGoogle() {
      return this.$store.getters.getUserDataLoginByGoogle
    },
    userDataLogin() {
      return this.$store.getters.getUserDataLogin
    }
  },
}
</script>
